















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Address, ClinicResponse, Consulation } from '@/interface/api'
import {
  DateFormat,
  TreatmentCategory,
  TreatmentCategoryOption
} from '@/utils/constants'
import { formatDate } from '@/utils/index'

@Component({
  name: 'ConfirmTemplate'
})
export default class ConfirmTemplate extends Vue {
  @Prop({ default: '' }) private medicalBusinessId!: string
  @Prop({ default: () => [] }) private clinics!: ClinicResponse[]
  @Prop({ default: () => null }) private consultation!: Consulation
  @Prop({ default: () => null }) private selectedClinic!: ClinicResponse
  @Prop({ default: '' }) private selectedClinicalDepartmentId!: string
  @Prop({ default: '' })
  private selectedClinicDeaprtmentTreatmentCourseId!: string

  @Prop({ default: '' }) private isFirstTreatment!: number
  @Prop({ default: '' }) private selectedTreatmentCategoryName!: string
  @Prop({ default: '' }) private selectedDoctorName!: string
  @Prop({ default: '' }) private customerDescription!: string
  @Prop({ default: new Date() }) private spotStartDatetime!: Date
  @Prop({ default: new Date() }) private spotEndDatetime!: Date
  @Prop({ default: false })
  private canFirstReservationForEachDoctorFlug!: boolean

  @Prop({ default: false })
  private canSecondLaterReservationForEachDoctorFlug!: boolean

  @Prop({ default: false }) private loading!: boolean

  private jointAddress(address: Address): string {
    return (
      address.prefecture +
      address.city +
      address.other1 +
      (address.other2 ? ' ' + address.other2 : '') +
      (address.other3 ? ' ' + address.other3 : '') +
      (address.other4 ? ' ' + address.other4 : '') +
      (address.other5 ? ' ' + address.other5 : '') +
      (address.other6 ? ' ' + address.other6 : '')
    )
  }

  private formatDate(date: Date): string {
    return formatDate(date, DateFormat.YYYYNEN_MMGATU_DDNICHI)
  }

  private formatDateTime(date: Date): string {
    return formatDate(date, DateFormat.HH_mm)
  }

  private get targetClinicalDepartment() {
    return this.selectedClinic!.clinical_departments.find(
      department => department.id === this.selectedClinicalDepartmentId
    )
  }

  private get isPreVisitQuestionnaireRequired() {
    if (
      !this.targetClinicalDepartment ||
      !this.consultation ||
      !this.consultation.questions
    )
      return false
    return (
      this.targetClinicalDepartment.has_to_answer_consultation &&
      this.consultation.questions.length > 0
    )
  }

  private get description(): string {
    if (!this.targetClinicalDepartment) return ''
    return this.selectedTreatmentCategoryName === TreatmentCategory.FcaeToFace
      ? this.targetClinicalDepartment.face_to_face_description
      : this.targetClinicalDepartment.video_description
  }

  private get displayEndTime(): number {
    if (!this.targetClinicalDepartment) return 0
    return this.targetClinicalDepartment.display_end_time
  }

  private get clinicalDepartmentName(): string {
    if (!this.targetClinicalDepartment) return ''
    const targetCourse = (
      this.targetClinicalDepartment.treatment_courses || []
    ).find(
      course => course.id === this.selectedClinicDeaprtmentTreatmentCourseId
    )
    return targetCourse
      ? `${this.targetClinicalDepartment.name} - ${targetCourse.name}`
      : this.targetClinicalDepartment.name
  }

  private get treatmentCategoryName(): string {
    const target = TreatmentCategoryOption.find(
      category => category.name === this.selectedTreatmentCategoryName
    )
    return target ? target.label : ''
  }

  private get customerFreeDescribe(): string {
    return this.customerFreeDescribe
  }
}
